import { FormatPipeline, type PipelineOptions } from '~/utils/formatters/prtials/formatPipeline';

export class DateFormatter {
  public static createPipeline(options: PipelineOptions<Date>) {
    return new FormatPipeline<Date>(options, DateFormatter);
  }

  public static daysToMilliseconds(days: number) {
    return days * 24 * 60 * 60 * 1000;
  }

  public static toReadableDate(date: Date) {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  public static toReadableTime(date: Date, config = { seconds: false }) {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      second: config.seconds ? '2-digit' : undefined,
      hour12: false
    });
  }
}
